<template>
    <div class="video-map-container">
        <div class="container">
            <h1>See your journey!... Why not check out the alternatives.</h1>
            <div class="video-map" id="mapScroller">
                <div class="level" :class="'level-' + level" v-for="level in levels">
                    <!-- Output for up to level 4 (last) -->
                    <div v-if="video.level == level && level != 4" class="video-item" :class="{
                        active: userChoices.indexOf(video.id) > -1,
                        'col-sm-12' : level == 1,
                        'col-sm-6' : level == 2,
                        'col-sm-3' : level == 3 || level == 4,
                        'last-level': level == levels.length
                    }" v-for="video in VideoType.questions">
                        <div class="video-item-inner">
                            <span class="map-bridge"></span>
                            <video-thumbnail :video="video" :year="year" :type="type" thumbnailFormat="video-map"></video-thumbnail>
                        </div>
                    </div>
                    <!-- Output for level 4 (last) -->
                    <!-- Divided into two, then four to get 8 col layout for level 4-->
                    <div class="col-sm-6" v-if="level == 4">
                        <div v-if="video.level == level && level == 4 && video.id <= 11" class="video-item" :class="{
                        active: userChoices.indexOf(video.id) > -1,
                        'col-sm-12' : level == 1,
                        'col-sm-6' : level == 2,
                        'col-sm-3' : level == 3,
                        'col-sm-3' : level == 4
                    }" v-for="video in VideoType.questions">
                            <div class="video-item-inner">
                                <span class="map-bridge"></span>
                                <video-thumbnail :video="video" :year="year" :type="type" thumbnailFormat="video-map"></video-thumbnail>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6" v-if="level == 4">
                        <div v-if="video.level == level && level == 4 && video.id > 11" class="video-item" :class="{
                        active: userChoices.indexOf(video.id) > -1,
                        'col-sm-12' : level == 1,
                        'col-sm-6' : level == 2,
                        'col-sm-3' : level == 3,
                        'col-sm-3' : level == 4,
                    }" v-for="video in VideoType.questions">
                            <div class="video-item-inner">
                                <span class="map-bridge"></span>
                                <video-thumbnail :video="video" :year="year" :type="type" thumbnailFormat="video-map"></video-thumbnail>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import VideoThumbnail from '../global/VideoThumbnail'
    export default {
        name: 'VideoMap',
        props: ['year', 'type', 'VideoData'],
        data : function(){
          return{
              levels : []
          }
        },
        components : {
            VideoThumbnail
        },
        created: function () {
            // Check if completed
            if(!this.$store.getters.getCompleted(this.year, this.type)) {
                this.$toasted.show('Please complete the video journey before viewing the video tree.', {
                    duration: 6000,
                    position: 'top-center',
                    type: "info",
                    action: {
                        text: 'CLOSE',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                });

                this.$router.push({
                    name: 'Video',
                    params: {
                        year: this.year,
                        type: this.type,
                        videoId: this.$store.getters.getlastVideoID(this.year, this.type) || 1
                    }
                });
            }

            
            this.VideoType = this.VideoData[this.year][this.type];
            console.log(this.VideoType);
            let vm = this;
            let levels = [];
            const length = Object.keys(this.VideoType.questions).length;
            Object.entries(this.VideoType.questions).forEach(([key, value]) => {
                if(!levels.includes(value.level)) { 
                    levels.push(value.level);
                }
                if(key == length) {
                    vm.levels = levels;
                }
            });

            this.userChoices = this.$store.getters.getVideoPath(this.year, this.type);
            console.log(this.userChoices);

            setTimeout(() => {
                var container = document.getElementById('mapScroller');
                if(window.innerWidth >= 600) {
                    this.sideScroll(container,'right',20,210,10);
                } else if (window.innerWidth >= 500) {
                    this.sideScroll(container,'right',20,270,10);
                } else {
                    this.sideScroll(container,'right',20,310,10);
                }
                
            }, 500);
        },
        methods: {
            sideScroll(element,direction,speed,distance,step){
                var scrollAmount = 0;
                var slideTimer = setInterval(function(){
                    if(direction == 'left'){
                        element.scrollLeft -= step;
                    } else {
                        element.scrollLeft += step;
                    }
                    scrollAmount += step;
                    if(scrollAmount >= distance){
                        window.clearInterval(slideTimer);
                    }
                }, speed);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/VideoMap.vue